import React from "react";
import { find } from "lodash";

import Button from "../Button";

import {
  Wrapper,
  Title,
  SummaryBlock,
  DossierBlock,
  TopicBlock,
  BlackText,
  RedText,
  Pic
} from "./styled";

import topics from "../topics";

function Summary({ onNext, character, topicIds }) {
  const topic = `${find(topics.first, { id: topicIds[0] }).t} ${
    find(topics.second, { id: topicIds[1] }).t
  } ${find(topics.third, { id: topicIds[2] }).t}`;

  return (
    <Wrapper>
      <Title>Тема что надо, у нас таких полно</Title>
      <SummaryBlock>
        <DossierBlock>
          <Pic id={character.character} />
          <BlackText>Научный руководитель:</BlackText>
          <RedText>{character.name}</RedText>
        </DossierBlock>
        <TopicBlock>
          <BlackText>Диссертация:</BlackText>
          <RedText>{topic}</RedText>
        </TopicBlock>
      </SummaryBlock>

      <Button onClick={() => onNext()}>Далее</Button>
    </Wrapper>
  );
}

export default Summary;
